import { type ReactNode, createContext, useContext } from 'react';
import type React from 'react';
import type { GridRowId, GridValidRowModel } from '@mui/x-data-grid';

export type RowDetailContextValue = {
  expandedRowId: GridRowId | null;
  toggleExpanded: (id: GridRowId) => void;
  getRowDetails: (row: GridValidRowModel) => React.ReactNode;
};

const RowDetailContext = createContext<RowDetailContextValue | null>(null);

export function RowDetailProvider({
  value,
  children,
}: {
  value: RowDetailContextValue | null;
  children: ReactNode;
}) {
  return (
    <RowDetailContext.Provider value={value}>
      {children}
    </RowDetailContext.Provider>
  );
}

export function useRowDetailContext() {
  return useContext(RowDetailContext);
}
